/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ArByPayerViewModel {
  carrier?: string | null;
  totalBalance?: number;
  percentageOfTotal?: number;
  balance0To30?: number;
  percentage0To30?: number;
  balance31To60?: number;
  percentage31To60?: number;
  balance61To90?: number;
  percentage61To90?: number;
  balance91To120?: number;
  percentage91To120?: number;
  balance121To150?: number;
  percentage121To150?: number;
  balance151Plus?: number;
  percentage151Plus?: number;
  rowNum?: number;
}
